// extracted by mini-css-extract-plugin
export default {"list":"IngresosLista_list__VMK3L"};